<nav
  class="flex items-center text-grey-400"
  [attr.aria-label]="'components.breadcrumb.ariaLabel' | translate"
>
  <a
    class="hover:text-grey"
    [routerLink]="['/']"
    [title]="'components.breadcrumb.home' | translate"
  >
    <svg-icon src="assets/icons/General/home-04.svg" class="block! size-4" />
  </a>
  <ng-container [ngTemplateOutlet]="separator" />

  @for (item of items; track item.label) {
    @if (!$last && item.route) {
      <a class="hover:text-grey" [routerLink]="item.route">{{
        item.label | translate
      }}</a>
    } @else {
      <span class="text-grey">{{ item.label | translate }}</span>
    }
    @if (!$last) {
      <ng-container [ngTemplateOutlet]="separator" />
    }
  }
</nav>

<ng-template #separator>
  <svg-icon
    src="assets/icons/Arrows/chevron-right.svg"
    class="mx-1 size-4 shrink-0"
    aria-hidden="true"
  />
</ng-template>
